const isFeatureOn = (key: string) => {
  const urlSearchParams = new URLSearchParams(window.location.search);

  return urlSearchParams.has(key);
};

export const isPwaOn = () => isFeatureOn('pwa');
